document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ctr-pill]').forEach((pill) => {
    const closeBtn = pill.querySelector('[data-ctr-pill-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        pill.hidden = true;
      });
    }

    const section = pill.closest('section');
    if (!section) return;

    pill.hidden = true;
    let revealed = false;
    let revealTimer = null;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !revealed) {
            revealTimer = setTimeout(() => {
              pill.hidden = false;
              revealed = true;
              observer.disconnect();
            }, 1000);
          } else if (!entry.isIntersecting && !revealed) {
            clearTimeout(revealTimer);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  });

});
